import {type StateTree} from "pinia";
import {UserV2Model} from "~~/package/mapper/user/model/UserV2Model";
import {SubscriptionModel} from "~~/package/mapper/subscription/model/SubscriptionModel";

export interface UserStoreState extends StateTree {
    firstName: string;
    userV2: UserV2Model;
    isBetaUser: boolean;
    redirectLocation: {
        path: string;
        query: Record<string, string | null | (string | null)[]>;
        name?: string | symbol | null | undefined;
        params: Record<string, string | string[]>;
    } | null;
    isUserInitialized: boolean;
    // True once the initial `getUserData()` in app.vue has resolved (either set
    // a logged-in user or failed and remained anon). Use to gate UI that
    // differs between anon vs logged-in (header CTAs, profile menu) so it
    // doesn't flash anon→logged-in after OAuth callback when public-marketing
    // routes are allowed to render before auth resolves.
    isAuthResolved: boolean;
    xCountry: string;
    subscription: SubscriptionModel | null;
}

export const state =  (): UserStoreState => ({
    firstName: '',
    userV2: new UserV2Model(),
    isBetaUser: false,
    redirectLocation: null,
    isUserInitialized: true,
    isAuthResolved: false,
    xCountry: '',
    subscription: null,
});
